<template>
  <v-col cols="12">
    <v-card>
      <v-card-title class="text-h5"> Rare/Unusual Purchases </v-card-title>

      <v-card-text>
        <p class="font-italic">
          Restricted to C-Level Owners with Minimum 3-years ownership history.
          <router-link to="/other/form4_search"> Search all transactions </router-link>
        </p>
        <p>
          We calculate the average # of purchases each owner makes within a calendar year. if they
          exceed that average within the timespan you specify then they will appear in the table
          below.
        </p>

        <!-- Options -->
        <v-row mt-6 mb-4>
          <v-col cols="12" sm="6" md="4" lg="3" xl="2">
            <v-text-field
              v-model="criteria.minimum_transaction_amount"
              type="number"
              prefix="$"
              label="Minimum $ amount"
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" xl="2">
            <v-select
              v-model="criteria.date_range"
              :items="tenFilterDates"
              item-title="text"
              label="Date range"
              hide-details
            />
          </v-col>
        </v-row>

        <!-- Table -->
        <v-data-table
          v-model:options="pagination"
          v-model:sort-by="pagination.sortBy"
          :headers="tableHeaders"
          :items="tableItems"
          :items-per-page-options="[10, 25, 50, 100]"
          :loading="loading"
          :no-data-text="loading ? 'Loading...' : 'No results found.'"
          must-sort
        >
          <template #item="{ item }">
            <tr>
              <td>
                <v-btn
                  :class="{ 'mr-4': $vuetify.display.smAndUp }"
                  small
                  title="View Transactions"
                  class="ma-0"
                  @click="$refs.transactionDetailsDialog.showDetails(item, criteria)"
                >
                  View transactions
                </v-btn>
              </td>
              <td>{{ item.symbol }}</td>
              <td>{{ item.filer_name }}</td>
              <td>
                <ul class="table-list">
                  <li v-for="title in item.officer_title" :key="title">
                    {{ title }}
                  </li>
                </ul>
              </td>
              <td>{{ percent(item.purchase_percent) }}</td>
              <td>{{ item.count }}</td>
              <td>{{ rounded_number(item.filer_avg_buys_per_year) }}</td>
              <td>{{ whole_number(item.transaction_shares) }}</td>
              <td>{{ currency(item.transaction_amount) }}</td>
              <td>{{ whole_number(item.last_shares_owned) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <transaction-details-dialog ref="transactionDetailsDialog" />
  </v-col>
</template>

<script>
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import api from '@/store/api'
import debounce from 'lodash/debounce'

// Mixins
import FormattersMixin from '@/mixins/formatters'

// Components
import TransactionDetailsDialog from '@/components/page/insider-dashboard/_TransactionDetailsDialog'

export default {
  components: {
    TransactionDetailsDialog
  },
  mixins: [FormattersMixin],

  data() {
    return {
      loading: false,
      tableHeaders: [
        { title: '', key: 'symbol', width: 1, sortable: false },
        { title: 'Ticker', key: 'symbol' },
        { title: 'Filer', key: 'filer_name' },
        { title: 'Title', key: 'officer_title' },
        { title: 'Purchase/Total Owned', key: 'purchase_percent' },
        { title: 'Trans. Count', key: 'count' },
        { title: 'Avg Buys Per Year', key: 'filer_avg_buys_per_year' },
        { title: 'Total Shares', key: 'transaction_shares' },
        { title: 'Total Amount', key: 'transaction_amount' },
        { title: 'Ownership', key: 'last_shares_owned' }
      ],
      tableItems: [],
      pagination: {
        sortBy: [{ key: 'transaction_amount', order: 'desc' }],
        page: 1,
        itemsPerPage: 10
      },
      criteria: {
        transaction_type: 2,
        date_range: 3,
        owner_types: 5,
        minimum_unique_owners: null,
        minimum_transaction_amount: null,
        show_infrequent: true
      },
      tenFilterDates: [
        { value: 0, text: 'Past Day' },
        { value: 1, text: 'Past 3 Days' },
        { value: 2, text: 'Past 7 Days' },
        { value: 6, text: 'Past 2 Weeks' },
        { value: 3, text: 'Past Month' },
        { value: 4, text: 'Past 3 Months' },
        { value: 5, text: 'Past 6 Months' },
        { value: 7, text: 'Past Year' }
      ]
    }
  },

  watch: {
    criteria: {
      deep: true,
      immediate: true,
      handler() {
        this.updateData()
      }
    }
  },

  methods: {
    updateData: debounce(function () {
      this.loading = true

      api
        .post('form4_agg_query', this.criteria)
        .then(response => {
          this.tableItems = response.data
        })
        .catch(error => {
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(() => (this.loading = false))
    }, 750)
  }
}
</script>
